import { render, staticRenderFns } from "./UserGuide.vue?vue&type=template&id=45b36ca7&scoped=true"
import script from "./UserGuide.vue?vue&type=script&lang=ts"
export * from "./UserGuide.vue?vue&type=script&lang=ts"
import style0 from "./UserGuide.vue?vue&type=style&index=0&id=45b36ca7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b36ca7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/myagent/_work/5/s/apps/front/flightpath-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b36ca7')) {
      api.createRecord('45b36ca7', component.options)
    } else {
      api.reload('45b36ca7', component.options)
    }
    module.hot.accept("./UserGuide.vue?vue&type=template&id=45b36ca7&scoped=true", function () {
      api.rerender('45b36ca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserGuide.vue"
export default component.exports